import type { IconPropsWithoutName } from '../index'

// biome-ignore lint/plugin: RETIRED, do not copy. Convert to a named function export when touching this.
export const CircleCheckFilled: React.FC<IconPropsWithoutName> = ({ color = 'white', className, ...props }) => {
  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: decorative icon; the Icon wrapper carries the accessible name
    <svg viewBox="0 0 60 61" fill="none" xmlns="http://www.w3.org/2000/svg" className={className} {...props}>
      <path
        d="M0 30.5C0 13.9315 13.4315 0.5 30 0.5C46.5685 0.5 60 13.9315 60 30.5C60 47.0685 46.5685 60.5 30 60.5C13.4315 60.5 0 47.0685 0 30.5Z"
        fill="#1AC9AA"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M45.963 18.203C46.679 18.9189 46.679 20.0798 45.963 20.7957L25.7964 40.9624C25.0804 41.6783 23.9196 41.6783 23.2036 40.9624L14.037 31.7957C13.321 31.0798 13.321 29.9189 14.037 29.203C14.7529 28.487 15.9137 28.487 16.6297 29.203L24.5 37.0733L43.3703 18.203C44.0863 17.487 45.2471 17.487 45.963 18.203Z"
        fill={color}
      />
    </svg>
  )
}
